import { createContext, useContext } from 'react';
import { ICohortRow, IRowMeta } from '../../../../redux/slices/oldBuilder';
import { assertNotNil } from '../../../../utils/types';

export interface ICohortRowContext {
  rowMeta: IRowMeta;
  cohortRow: ICohortRow;
  isTimeToConvertRow: boolean;
}

export const CohortRowContext = createContext<ICohortRowContext | null>(null);

export const useCohortRowContext = () => {
  const contextValues = useContext(CohortRowContext);
  assertNotNil(contextValues);
  return contextValues;
};

// selectors for timeToConvert values
export const useCohortRowOperatorAndValues = () => {
  const { cohortRow, isTimeToConvertRow } = useCohortRowContext();
  const { timeToConvert } = cohortRow;
  return {
    operator: isTimeToConvertRow ? timeToConvert?.operator : cohortRow.operator,
    operatorValues: isTimeToConvertRow
      ? timeToConvert?.operatorValues
      : cohortRow.operatorValues,
  };
};
